<div class="gb-popup">
  <div class="gb-popup-inner">
    <div mat-dialog-title class="gb-popup-header">
      <h2>{{ "genera-posizione-titolo" | translate }}</h2>
      <h4>{{ "genera-posizione-sottotitolo" | translate }}</h4>
      <hr />

      <button type="button" [title]="'genera-posizione-chiudi' | translate"
        attr.aria-label="{{ 'genera-posizione-chiudi' | translate }}" tabindex="-1"
        class="gb-close-pp gb-button-reset" (click)="close('chiudi')">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ "genera-posizione-chiudi" | translate }}</em>
      </button>
    </div>
    <div mat-dialog-content class="gb-popup-main">
      <div class="d-flex mb-4 justify-content-evenly">
        <div>{{data.numeroAvviso | numeroAvvisoDescription}}:</div>
        <div>{{data.numeroAvviso}}</div>
      </div>
      <div class="mb-4 text-bold" [innerHTML]="'genera-posizione-descrizione' | translate | safeHtml"></div>
    </div>
    <div class="gb-popup-foot">
      <button type="button" (click)="close('ristampa')" class="gb-button-reset gb_btncta small me-3" tabindex="-1">
        {{ "genera-posizione-ristampa" | translate }}
      </button>
      <button type="button" (click)="close('paga')" class="gb-button-reset gb_btncta small" [disabled]="data.pagato"
        tabindex="-1">
        {{ "genera-posizione-paga" | translate }}
      </button>
    </div>
  </div>
</div>
